import { TabsConfig, useTabs } from '@hooks/useTabs'
import { useIntl } from 'react-intl'
import Permissions from './RolesAndPermissions'
import { AdminPanelSettings, GroupsSharp } from '@mui/icons-material'
import { Groups } from './Groups'
import { Box, Tab, Tabs } from '@mui/material'

const rolesConfig = (intl: ReturnType<typeof useIntl>): TabsConfig => ({
  roles: {
    id: 'roles-permissions',
    label: intl.formatMessage({ id: 'roles-and-permissions' }),
    component: Permissions,
    icon: <AdminPanelSettings />,
  },
  groups: {
    id: 'administration-groups',
    label: intl.formatMessage({ id: 'groups-managment' }),
    component: Groups,
    icon: <GroupsSharp />,
  },
})

export const Roles = () => {
  const intl = useIntl()
  const tabsConfig = rolesConfig(intl)
  const { keys, index, onChange, Component } = useTabs(tabsConfig)

  return (
    <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
      <Box
        sx={{
          backgroundColor: '#fff',
          borderBottom: '1px solid',
          borderColor: 'grey.200',
          px: 4,
        }}
      >
        <Tabs
          indicatorColor="primary"
          textColor="primary"
          value={index[0]}
          onChange={onChange[0]}
          aria-label="equipment-tabs"
          sx={{
            '& .MuiTabs-indicator': {
              height: 2,
              backgroundColor: 'primary.main',
            },
            '& .MuiTab-root': {
              textTransform: 'none',
              fontWeight: 500,
              fontSize: '0.875rem',
              minHeight: 48,
              mr: 4,
              px: 0,
              color: 'text.secondary',
              '&.Mui-selected': {
                color: 'primary.main',
              },
            },
          }}
        >
          {keys.map((key) => {
            return (
              <Tab
                key={key}
                label={
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {tabsConfig[key].icon}
                    {tabsConfig[key].label}
                  </Box>
                }
                id={`tab-${key}`}
                aria-controls={`tabpanel-${key}`}
              />
            )
          })}
        </Tabs>
      </Box>
      <Box
        sx={{
          flex: 1,
          overflow: 'auto',
          backgroundColor: '#f9fafb',

          p: 2,
        }}
      >
        {Component && <Component />}
      </Box>
    </Box>
  )
}
